import { render, staticRenderFns } from "./OldLocationCard.vue?vue&type=template&id=53952c4e&"
import script from "./OldLocationCard.vue?vue&type=script&lang=js&"
export * from "./OldLocationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports